import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  viewEulaContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginTop: theme.spacing(-1),
  },
  viewEulaDescription: {
    margin: theme.spacing(0),
    fontSize: '14px',
    color: theme.palette.labraText.description,
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
  },
  docsLink: {
    fontSize: '16px !important',
  },
}))
